import clsx from 'clsx';
import type { ReactNode } from 'react';

type Tone = 'neutral' | 'info' | 'ok' | 'warn' | 'danger';

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return <span className={clsx('badge', tone !== 'neutral' && tone)}>{children}</span>;
}
